class StorageKeys {
  UserEmail = "i_email";
  PASSWORD = "i_password";
  BIBLEVERSE = "i_bibleText";
  UserHighlight = "i_Highlight";
  UserData = "u_userdata";
  UserComment = "u_comment";
  UserName = "i_username";
  UserIntroduction = "u_introduction";
  UserCountry = "u_country";
  UserReligion = "u_religion";
  UserQuotes = "u_quotes";
  PictureBackground = "p_formData_background";
  PictureProfile = "p_formData_profile";
  PictureName = "p_Name";
  EMAIL = "u_email";
  SupabaseUrlProfile =
    "https://kbuzjqfgjvrgbivzbxjb.supabase.co/storage/v1/object/public/tanyapendeta%20bucket/profile_";
  SupabaseChurchUrlProfile =
    "https://kbuzjqfgjvrgbivzbxjb.supabase.co/storage/v1/object/public/tanyapendeta%20bucket/church_images/";

  discussionData = "discussionData";
  discussionForumData = "discussionForumData";
}

export default new StorageKeys();
